import { render, staticRenderFns } from "./BooleanToggle.vue?vue&type=template&id=4fb10d2c&scoped=true"
import script from "./BooleanToggle.vue?vue&type=script&lang=js"
export * from "./BooleanToggle.vue?vue&type=script&lang=js"
import style0 from "./BooleanToggle.vue?vue&type=style&index=0&id=4fb10d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb10d2c",
  null
  
)

export default component.exports